import React, { CSSProperties } from 'react';
import { faBuilding } from '@fortawesome/free-regular-svg-icons';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';

import Icon, { faArrowRight, faBan, faCar, faHouse } from '~components/icon';

import TooltipPortal from '../TooltipPortal';

const TRAVEL_BASE_TYPE_HOME = 'home';

interface Travel {
  type: string;
  distance: number | string;
  is_conflict?: boolean;
  duration: number | string;
  is_visual?: boolean;
  from?: TravelPoint;
  to?: TravelPoint;
}

interface TravelPoint {
  time: string | null;
  address: string;
  type?: string | null;
}

interface ComponentProps {
  travel: Travel;
  style?: CSSProperties;
}

const TravelCard: React.FC<ComponentProps> = ({ travel, style }) => {
  const { distance, duration, type, is_conflict, is_visual, from, to } = travel;
  const cardId = `travel-card-${type}-${uuid()}`;
  const className = classNames('travel-card', {
    [`${type}`]: type !== undefined,
    visualised: is_visual,
    'travel-conflict': is_conflict,
  });

  let icon;
  let arrow;
  if (type && (type.includes('start') || type.includes('end'))) {
    const typeIcon = from?.type === TRAVEL_BASE_TYPE_HOME || to?.type === TRAVEL_BASE_TYPE_HOME ? faHouse : faBuilding;
    icon = from?.address ? typeIcon : faBan;
    arrow = faArrowRight;
  } else {
    icon = faCar;
  }

  const toolTipDetails = (
    <>
      <span>Duration: ~{typeof duration === 'number' ? Math.round(duration) : duration} mins</span>
      <br />
      <span>Distance: ~{typeof distance === 'number' ? distance?.toFixed(2) : distance} kms</span>
      <br />
    </>
  );

  const noTooltipDetails = (
    <>
      <span>No Travel - Invalid home address</span>
    </>
  );

  const tooltipContent = (
    <div>
      <strong>Travel</strong>
      <br />
      {from?.address ? toolTipDetails : noTooltipDetails}
    </div>
  );

  return (
    <>
      <div id={cardId} className={className} style={style}>
        <div className="icons">
          {icon && <Icon icon={icon} size="sm" />}
          {arrow && <Icon icon={arrow} size="sm" />}
        </div>
        <span>~ {typeof distance === 'number' ? distance?.toFixed(2) : distance} kms</span>
      </div>
      <TooltipPortal targetId={cardId} content={tooltipContent} placement="top" />
    </>
  );
};

export default TravelCard;
